import { useState } from 'react';
import { Heading, InfoButton, Inline, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css, mediaQueries } from '@eti/styles';
import ReadMoreModal from '../../../common/components/ProductReadMoreModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const headingStyles = css`
  @media ${mediaQueries.small.only} {
    align-items: center;
  }

  margin-inline-start: 0;
`;
const BaggageSectionHeader = _ref => {
  let {
    productName,
    title,
    travelerId,
    readMoreModal
  } = _ref;
  const {
    t
  } = useTranslation();
  const [isReadMoreModalOpen, setIsReadMoreModalOpen] = useState(false);
  return /*#__PURE__*/_jsx(Stack, {
    "data-testid": `travelerDetails-productSection-product-${productName}-header-${travelerId}`,
    children: /*#__PURE__*/_jsxs(Inline, {
      align: "start",
      "data-testid": `baggage-header-wrapper-${productName}`,
      spacing: 8,
      children: [/*#__PURE__*/_jsx(Heading, {
        className: headingStyles,
        "data-testid": `baggage-header-${productName}-title`,
        id: `baggage-header-${productName}-title`,
        level: 3,
        children: title
      }), readMoreModal && readMoreModal.isEnabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(InfoButton, {
          "aria-describedby": `baggage-header-${productName}-title`,
          "data-testid": `${productName}-readMoreIcon-${travelerId}`,
          label: `baggage-header-${productName}-title`,
          onClick: () => setIsReadMoreModalOpen(true)
        }), /*#__PURE__*/_jsx(ReadMoreModal, {
          content: readMoreModal.content,
          modalConfirmLabel: t('Products.ReadMore.Modal.Confirm.Label'),
          onClose: () => setIsReadMoreModalOpen(false),
          productName: productName,
          show: isReadMoreModalOpen,
          title: title
        })]
      })]
    })
  });
};
export default BaggageSectionHeader;